import { createFileRoute } from "@tanstack/react-router"

import { ManagementBerichtePage } from "@/components/admin/management-berichte-page"

export const Route = createFileRoute("/_app/management/berichte")({
  component: ManagementBerichtePage,
})
